module.exports = __webpack_public_path__ + "static/media/magee-secondary-school.8e75e891.jpg";